import axios from 'axios';

// const backEndApiClient = axios.create({
//     timeout: 10000, //10 seconds
//     headers: {
//         'Content-Type': 'application/json',
//     },
// });

const blynkApiClient = axios.create({
    baseURL: process.env.REACT_APP_BLYNK_BASE_URL,
    timeout: 10000, //10 seconds
    headers: {
        'Content-Type': 'application/json',
    },
});

// export function setBackendBaseUrl(url) {
//     backEndApiClient.defaults.baseURL = url;
// }

export {blynkApiClient };